const configTooltipProvider = $tooltipProvider => {
	$tooltipProvider.options({placement: 'top', appendToBody: true});
};
configTooltipProvider.$inject = ['$uibTooltipProvider'];
export default configTooltipProvider;
